import Hero from './components/Hero';
import Problem from './components/Problem';
import Affinity from './components/Affinity';
import Solution from './components/Solution';
import HowIIJReducesRisk from './components/HowIIJReducesRisk';
import OfferNarrowing from './components/OfferNarrowing';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Problem />
      <Affinity />
      <Solution />
      <HowIIJReducesRisk />
      <OfferNarrowing />
      <FinalCTA />
      <Footer />
    </div>
  );
}
